import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-number-box";
import "./../../bindings/bao-date-time-picker";
function InstructionSerialModel(serialModel, initDate) {
    var self = this;
    var subscriptions = [];
    self.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
    self.Dialog.Width(900);
    self.Dialog.Buttons([{
            Title: Bao.Session.GetMessage("msgOk"),
            Click: function () {
                self.CompleteCheck().then(function (valid) {
                    self.CheckDaysInPeriod().then(function (result) {
                        if (self.FlagCheckDaysinPeriod() == true) {
                            if (valid && result) {
                                self.DialogResult(ko.map.toJS(self.DialogViewModel));
                                self.Dialog.Close();
                            }
                        }
                        else {
                            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgSelectedDaysnotinPeriod"), "info");
                        }
                    });
                });
            },
            Enabled: ko.observable(true)
        }, {
            Title: Bao.Session.GetMessage("msgCancel"),
            Click: function () {
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }, {
            Title: Bao.Session.GetMessage("msgDeleteSeries"),
            Click: function () {
                var questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgQuestionDeleteSeries"), "yesno");
                questionDialog.DialogResult.subscribe(function (dialogResult) {
                    if (dialogResult == true) {
                        self.DialogResult("delete");
                        self.Dialog.Close();
                    }
                });
            },
            Enabled: ko.observable(true)
        }]);
    self.DialogViewModel = {};
    self.DialogViewModel.Bao = Bao;
    self.DialogViewModel.StartTimeJs = ko.observable(initDate);
    self.DialogViewModel.EndTimeJs = ko.observable(initDate);
    self.FlagCheckDaysinPeriod = ko.observable(false);
    self.DialogResult = ko.observable();
    self.DialogViewModel.FrequencyString = ko.observable();
    self.DialogViewModel.CycleValue = ko.observable();
    self.DialogViewModel.CycleValueDefault = ko.observable();
    self.DialogViewModel.CycleValueDefault2 = ko.observable();
    self.DialogViewModel.MonthlyDayCycle = ko.observable();
    self.DialogViewModel.MonthlyWeekdayCycle = ko.observable();
    self.DialogViewModel.SelectedDays = ko.observableArray();
    self.DialogViewModel.Days = ko.observable();
    self.DialogViewModel.MonthlyType = ko.observable();
    self.DialogViewModel.CycleValueMonthly1 = ko.observable();
    self.DialogViewModel.CycleValueDefaultMonthly1 = ko.observable();
    self.DialogViewModel.CycleValueMonthly2 = ko.observable();
    self.DialogViewModel.CycleValueDefaultMonthly2 = ko.observable();
    self.DialogViewModel.CycleValueDefaul2tMonthly2 = ko.observable();
    subscriptions.push(self.DialogViewModel.MonthlyDayCycle.subscribe(function (dayCycle) {
        if (typeof dayCycle === "number") {
            self.DialogViewModel.MonthlyDayCycle(dayCycle.toString());
        }
        else {
            self.DialogViewModel.CycleValue(dayCycle);
        }
    }));
    subscriptions.push(self.DialogViewModel.MonthlyWeekdayCycle.subscribe(function (weekDayCycle) {
        if (typeof weekDayCycle === "number") {
            self.DialogViewModel.MonthlyWeekdayCycle(weekDayCycle.toString());
        }
        else {
            self.DialogViewModel.CycleValueDefault(weekDayCycle);
        }
    }));
    subscriptions.push(self.DialogViewModel.MonthlyType.subscribe(function (type) {
        if (type == "1") {
            self.DialogViewModel.CycleValueDefault2(null);
        }
        else if (self.DialogViewModel.CycleValueDefault2() == null) {
            self.DialogViewModel.CycleValueDefault2(1);
        }
    }));
    subscriptions.push(self.DialogViewModel.SelectedDays.subscribe(function (array) {
        var s = "";
        for (var i = 0; i < array.length; i++) {
            s = s + ko.unwrap(array[i]) + ";";
        }
        self.DialogViewModel.Days(s);
    }));
    subscriptions.push(self.DialogViewModel.Days.subscribe(function (s) {
        if (!Bao.Utils.String.IsNullOrWhitespace(s)) {
            var array = s.split(";");
            if (array != null) {
                array.splice(array.length - 1, 1);
            }
            self.DialogViewModel.SelectedDays(array);
        }
    }));
    subscriptions.push(self.DialogViewModel.FrequencyString.subscribe(function (s) {
        if (!Bao.Utils.String.IsNullOrWhitespace(s) && s != "1") {
            self.DialogViewModel.SelectedDays([]);
        }
    }));
    self.CheckDaysInPeriod = function () {
        var def = $.Deferred();
        Bao.post("Instruction/CheckDaysinPeriod", JSON.stringify({
            startDate: self.DialogViewModel.StartTimeJs(),
            enddate: self.DialogViewModel.EndTimeJs(),
            days: self.DialogViewModel.SelectedDays()
        }), function (result) {
            if (result.Result == true) {
                self.FlagCheckDaysinPeriod(true);
                def.resolve(true);
            }
            else {
                self.FlagCheckDaysinPeriod(false);
                def.resolve(false);
            }
        });
        return def.promise();
    };
    self.CompleteCheck = function () {
        var def = $.Deferred();
        Bao.post("Instruction/ValidateInstructionSerial", JSON.stringify({
            model: ko.map.toJS(self.DialogViewModel)
        }), function (result) {
            if (result.Result == true) {
                def.resolve(true);
            }
            else {
                new BaoDialogViewModel(Bao.Session.ApplicationName, result.Message, "info");
                def.resolve(false);
            }
        });
        return def.promise();
    };
    self.Show = function (instructionSerialId) {
        self.Dialog.Open();
        self.Dialog.IsLoading(true);
        Bao.post("Instruction/ShowInstructionSerialDialog", JSON.stringify({
            instructionSerialId: instructionSerialId
        }), function (value) {
            if (Bao.Utils.String.IsNullOrEmpty(value.Model.StartTimeJs)) {
                value.Model.StartTimeJs = initDate;
            }
            if (Bao.Utils.String.IsNullOrEmpty(value.Model.EndTimeJs)) {
                value.Model.EndTimeJs = initDate;
            }
            if (serialModel == null) {
                ko.map.fromJS(value.Model, self.DialogViewModel, ko.dirtyFlag());
            }
            else {
                ko.map.fromJS(ko.toJS(serialModel), self.DialogViewModel, ko.dirtyFlag());
            }
            self.Dialog.ViewModel(self.DialogViewModel);
            self.Dialog.Template(value.Message);
            self.Dialog.IsLoading(false);
        });
    };
}
export default InstructionSerialModel;